<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-paste"></i>
          서버 정보
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WEBCastle</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">Server</a>
          </li>
      </ul>
    </div>
    <vcl-facebook v-if="loading"></vcl-facebook>
    <b-card v-else>
      <!-- <template slot="header">
        <i class='fa fa-align-justify' v-if="server && server.url"></i>
        <span>에이전트 정보</span>
        <strong class="pull-right">{{server.nickname}}@{{server.version}} / {{server.created_at | datetime}}</strong>
      </template> -->
      <template v-if="quick_setting_status" class="animated fadeIn fadeOut">
        <hr>
        <RuleQuickSetup
          v-if="default_rule && default_rule.rule"
          :rule_selected="sel_domain.rule"
          :domain="sel_domain.domain"
          :quick_setting="quick_setting"
          :ico="ico"
          :is_one="is_one"
          :crs_rule="default_rule.rule"
          :setting_level="setting.level"
          :setting_mode="setting.mode"
          :user="user"
          :is_first="is_first"

          @save_default="save_default"
          @status="() => { quick_setting_status = false; is_first = false }"
          @quick_setting_update="(data) => { quick_setting = Object.assign({}, quick_setting, data) }"
        >
        </RuleQuickSetup>
      </template>
      <b-card v-if="server && !quick_setting_status">
        <b-row>
          <b-col md="8">
            <b-form-checkbox v-model="setting.status" v-on:change="status_save($event, setting.status)" name="check-button" switch>
              웹캐슬 엔진 (글로벌)
              On / Off
            </b-form-checkbox>
          </b-col>
          <b-col md="4">
            <b-button class="pull-right" size="sm" variant="outline-primary" @click="quick_setting_status = true">빠른 설정 시작 </b-button>
          </b-col>
        </b-row>
      </b-card>
      <b-card v-if="server && !quick_setting_status">
        <b-row class="text-center" v-if="server.os_type">
          <b-col sm="2">
            <span style="cursor: pointer;" @click="modal_name = true">이름 (<i class="fa fa-question"></i>)</span>
            <br>
            <b-button variant="link" @click="nickname_modify_modal = true">{{server.nickname}}</b-button>
          </b-col>
          <b-col sm="2">
            IP
            <br>
            {{ (server.ip_addr_public && server.ip_addr_public == server.ip_addr_private ? server.ip_addr_public : server.ip_addr) || '-' }}
            <!-- {{server.ip_addr || '-'}} -->
          </b-col>
          <b-col sm="2">
            OS
            <br>
            {{server.os_type || '-'}}
          </b-col>
          <b-col sm="2">
            WAS
            <br>
            {{server.iwaf_type  || '-'}}
          </b-col>
          <b-col sm="2">
            Version
            <br>
            {{server.version || '-'}}
          </b-col>
          <b-col sm="2">
            Status
            <br>
            <b-badge variant="success" v-if="info.ms">온라인</b-badge>
            <b-badge v-else variant="secondary">오프라인</b-badge>
          </b-col>
        </b-row>
        <hr>
        <b-row class="text-center">
          <b-col md="3" style="cursor: pointer;">
            <strong class="mb-2" @click="explain_user_crs = true">가상 도메인 선택(?) </strong>
            <hr>
            <b-form-select v-model="sel_domain.domain" @change="change_domain($event, sel_domain.id)" size="sm" style="max-width: 20rem;">
              <option v-for="item in server.policy_json.domains" :key="item.id" :value="item.domain">{{item.domain}}</option>
            </b-form-select>
          </b-col>
          <b-col md="3" style="cursor: pointer;">
            <strong style="cursor: pointer;" @click="explain_level = true">보안 정책 레벨 <span>(?)</span></strong>
            <hr>
            <!-- <small style="cursor: pointer;" @click="explain_level = true">( Level : {{setting.level}} )</small> -->
            <b-form-radio-group v-model="setting.level" style="cursor: pointer;" id="ph_level" @change="(x) => { change_level_value.prev = change_level_value.new; change_level_value.temp = change_level_value.prev;  change_level_value.new = x; change_level_value.prev < change_level_value.new ? change_level_modal = true : $refs.RuleSelector.$children.forEach(r => r.parser_setting()) }" :options="codes.WAF_LEVEL"></b-form-radio-group>
          </b-col>
          <b-col md="4" style="text-align: center; cursor: pointer;">
            <strong @click="explain_mode = true">방화벽 모드(?) :
              <b-badge v-if="setting.mode == 0" variant="secondary">미사용</b-badge>
              <b-badge v-if="setting.mode == 1" variant="warning">탐지 모드</b-badge>
              <b-badge v-if="setting.mode == 2" variant="danger">차단</b-badge>
            </strong>
            <hr>
            <b-form-radio-group id="ph_mode"
              @change="(x) => { change_mode_value.prev = change_mode_value.new; change_mode_value.temp = change_mode_value.prev; change_mode_value.new = x; }"
              v-model="setting.mode" :options="codes.WAF_MODE_OPTION_KOR">
            </b-form-radio-group>
          </b-col>
          <b-col md="2">
            <div>
              <b-button block size="sm" class="btn-add" variant="success" @click="rule_confirm = true">적용</b-button>
              <b-button block size="sm" class="mb-2" variant="warning" @click="apply_modal = true">다른 서버로 적용</b-button>
              <b-button block size="sm" class="mb-2" variant="primary" @click="explain_user_crs = true">도메인 관리</b-button>
            </div>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col md="10">
            <b-form-group>
              <h5>
                <b-badge variant="warning">공지</b-badge>
                <small> <strong> 보안 정책 레벨이 1 이상으로 설정되면 운용중인 서비스에 영향을 줄 수 있습니다. </strong></small><br>
                <small> <strong> * 미사용 : 현재 선택한 도메인에 대해 방화벽 기능 사용안함 </strong></small><br>
                <small> <strong> * 탐지모드 : 방화벽 기능에서 탐지만 활용 </strong></small><br>
                <small> <strong> * 차단모드 : 방화벽 기능에서 차단 사용 </strong></small><br>
                <!-- <small> <strong> * Multiplexing : Managed by a multiplexed firewall policy </strong></small> -->
              </h5>
            </b-form-group>
          </b-col>
          <b-col>
            <b-row>
              <b-col>
                <!-- <b-button class="" size="sm" block variant="outline-success" @click="download_policy()">정책 내보내기</b-button>
                <b-button class="mt-2" size="sm" block variant="outline-info" @click="upload_policy = true">정책 가져오기</b-button> -->
                <b-button size="sm" v-if="server.is_alive" block @click="modal_del = true" variant="danger">삭제</b-button>
                <b-button class="mt-2" size="sm" block variant="light" @click="list()">목록으로</b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card>
      <!-- 탭부분 시작 -->
      <b-tabs v-model="tabIndex" v-if="server && !quick_setting_status">
        <!-- 방화벽 기본 정책 설정 -->
        <b-tab style="cursor: pointer;" title="정책 (CRS)">
          <b-row>
            <b-col>
              <strong>방화벽 정책을 설정할 수 있으며 사용 또는 사용 안함으로 설정할 수 있습니다.</strong>
              <!-- 1. Quick은 사용하는 서비스 선택, (기본 설정들 보여줌) -->
              <!-- 2. allow ip 선택 -->
              <!-- <span class="pull-right">버전 : <strong >{{ default_rule.version }}</strong></span> -->
              <b-form-select class="float-right ml-2" v-model="target_crs_rule" @change="() => change_main_policy = true" size="sm" style="max-width: 10rem;">
                <option  v-for="item in crs_version_list" :value="item">{{item.version}}</option>
              </b-form-select>
              <Bell style="float:right; margin-top:5px;" :size="20" :count="crs_rule_count" v-if="get_max_policy()" />
            </b-col>
          </b-row>
          <hr>
          <p block class="bg-danger p-1 pl-3 pr-3 fadeIn fadeOut rounded-pill" v-if="policy_changed && policy_changed.length > 0">
            <strong>* 변경된 정책이 있어 저장을 권장합니다, 레벨 변경시 저장되지 않은 변경 사항이 원복될 수 있습니다</strong>
          </p>
          <RuleService
            v-if="!quick_setting_status"
            :quick_setting="quick_setting"
            :ico="ico"
            @toggle_policy="toggle_policy"

          >  </RuleService>
          <hr v-if="!quick_setting_status" class="animated fadeIn fadeOut">
          <template v-if="!quick_setting_status" class="animated fadeIn fadeOut">
            <RuleSelector
              class="animated fadeIn fadeOut"
              ref="RuleSelector"

              :rule_selected="sel_domain.rule"
              :rule_data="rule_set.rule"
              :rule_block="sel_domain.block"
              :rule_detect="sel_domain.detect"
              :mode="setting.mode"
              :level="setting.level"
              :opened="rule_open"

              @policy_rule="policy_rule"
              @quick_policy_one="(data) => quick_setting = Object.assign({}, quick_setting, data)"
              @block_policy="(block) => sel_domain = Object.assign({}, sel_domain, { block : block })"
              @detect_policy="(detect) => sel_domain = Object.assign({}, sel_domain, { detect : detect })"
              @rule_sel="(x) => sel_domain = Object.assign({}, sel_domain, { rule : x })"
              @rule_open="(x) => filter_rule_open(x)"
              @is_changed="(x) => policy_changed = x"

              v-bind:toss_rule="save"
              v-if="sel_domain"
            />
           </template>
        </b-tab>
        <!-- 방화벽 사용자 설정 -->
        <!-- custom 문법 체크가 필요함 -->
        <b-tab style="cursor: pointer;" title="사용자 지정 정책 (Custom-CRS)">
          <b-row>
            <b-col>
              <strong>
                <b-badge variant="warning">공지</b-badge> : 전문가만 사용을 권장드립니다.
                <hr>
                사용자 지정 CRS 설정
              </strong><br><br>
              <span>사용자가 규칙을 정의할 수 있습니다..</span><br>
              <strong>규칙 ID 6000000-+ ID를 지정하십시오.</strong>
              <!-- 커스텀 부분으로 룰 활성화 부분 안내 -->
              <hr>
              <b-form-group>
                <b-form-checkbox v-model="is_redir"><p class="text-danger text-bold">차단 모드에서 탐지 시 리디렉션을 제공합니다.</p></b-form-checkbox>
                <b-form-input placeholder="Example) http://f1security.co.kr/warning.html" v-model="using_redir" @change="redir_change"></b-form-input>
              </b-form-group>
              <hr>
              "호스트 헤더가 IP 주소로 요청될 때" 탐지되는 규칙은 920350 입니다
              <br>
              <br>
              Example : SecRuleUpdateActionById 920350 "t:none,msg:'Network Attack',allow"
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col>
              <b-form-group>
                <b-form-textarea id="ph_content" v-model="user.custom_rule" :rows="line_count()" :max-rows="80"></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-tab>
        <!-- ip 관련 접근 제어 -->
        <b-tab style="cursor: pointer;" title="IP 주소">
          <RuleIP
            class="animated fadeIn fadeOut"
            @block_ip="($val, key) => user.block_ip = $val"
            @allow_ip="($val, key) => user.allow_ip = $val"
            :origin="{ allow_ip : user.allow_ip, block_ip: user.block_ip }"
            :is_setup="false"
            :setting="{ mode: server.mode, level : setting.level }"
          ></RuleIP>
        </b-tab>
        <b-tab style="cursor: pointer;" title="경로 & 파라미터(Query String)">
          <b-row>
            <b-col>
              <!-- path 관련 사용자 정책 설정 -->
              <!-- @update 에서 key 는 구분자임 -->
              <RuleCustom
                class="animated fadeIn fadeOut"
                :origin="user.path"
                type="path"
                name="경로 관리"
                :is_setup="false"
                example="/admin,/manager"
                @update="($val, key) => user.path = $val"
              ></RuleCustom>
            </b-col>
            <b-col>
              <!-- 파라미터 관련 사용자 설정 -->
              <!-- @update 에서 key 는 구분자임 -->
              <RuleCustom
                class="animated fadeIn fadeOut"
                :origin="user.parameter"
                type="params"
                name="파라미터 관리"
                example="id=test : Detects if query string has id=test,test : Detects if query string has test"
                :is_setup="false"
                @update="($val, key) => user.parameter = $val"
              ></RuleCustom>
            </b-col>
          </b-row>
        </b-tab>
        <!-- CUSTOM country code -->
        <b-tab style="cursor: pointer;" title="국가">
          <RuleCountry
            ref="_country"
            class="animated fadeIn fadeOut"
            :origin="user.country_code"
            :origin_use_geoip="user.use_geoip"
            :db_update_available="db_update_available()"
            :mmdb_version="server.mmdb_version"
            :mmdb_latest="webcastle_mmdb"

            name="country_code"
            @update="($val, key) => user.country_code = $val"
            @use_geoip="($val, key) => user.use_geoip = $val"
            @update_db="db_update_cmd"
          />
        </b-tab>
        <!-- <b-tab style="cursor: pointer;" title="메소드">
          <RuleMethod
            ref="_method"
            class="animated fadeIn fadeOut"
            :origin="user.method_control"
            :origin_use_method="user.use_method"
            :now_mode="setting.mode"

            name="method"
            @update="($val, key) => user.method_control = $val"
            @use_method="($val, key) => user = Object.assign({}, user, { use_method : $val })"
          />
        </b-tab> -->
        <b-tab style="cursor: pointer;" title="로그" @click="refresh()">
          <b-row>
            <b-col>
              <strong>서버에 대한 탐지/차단 로그를 표시합니다.</strong><br><br>
              <span>* 마지막 50건의 실시간으로 표시됩니다.</span><br>
              <span v-if="th" class="float-right">
                <i class="fa fa-refresh fa-spin"></i>
                실시간 업데이트
              </span>
              <br><br>
              <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found" class="table-responsive table_add"
                :items="getItems" :fields="fields" :current-page="currentPage" :per-page="50">
                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>
                <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
                <template slot="created_at" slot-scope="row">{{row.item.created_at|datetime}}</template>
                <template slot="remote_addr" slot-scope="row">
                  {{row.item.remote_addr}}
                  <span v-if="row.item.country" class="flag-icon" :class="set_flag(row.item.country)"></span>
                </template>
                <template slot="is_block" slot-scope="row">
                  <b-badge v-if="row.item.is_block && row.item.block_cnt > 0" variant="danger">차단</b-badge>
                  <b-badge v-else variant="warning">탐지</b-badge>
                </template>
                <template slot="message" slot-scope="row">
                  <strong @click="log_view(row.item)">
                    {{ruleI18n[row.item.message.details.ruleId] ? ruleI18n[row.item.message.details.ruleId]['KO'] : row.item.message.message }}
                  </strong>
                </template>
                <template slot="ruleid" slot-scope="row">
                  {{row.item.message ? row.item.message.details.ruleId : row.item.m_id }}
                </template>
                <template slot="severity" slot-scope="row">
                  <span scope="row" v-if="row.item.message.details.severity == 0"><b-badge variant="danger">긴급</b-badge></span>
                  <span scope="row" v-else-if="row.item.message.details.severity == 1"><b-badge variant="danger">경계</b-badge></span>
                  <span scope="row" v-else-if="row.item.message.details.severity == 2"><b-badge variant="danger">치명적</b-badge></span>
                  <span scope="row" v-else-if="row.item.message.details.severity == 3"><b-badge variant="warning">에러</b-badge></span>
                  <span scope="row" v-else-if="row.item.message.details.severity == 4"><b-badge variant="warning">주의</b-badge></span>
                  <span scope="row" v-else-if="row.item.message.details.severity == 5"><b-badge variant="info">정보</b-badge></span>
                  <span scope="row" v-else-if="row.item.message.details.severity == 6"><b-badge variant="info">정보</b-badge></span>
                  <span scope="row" v-else><b-badge variant="dark">미정의</b-badge></span>
                </template>
                <template slot="uri" slot-scope="row">
                  {{row.item.uri | truncate(50) }}
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab style="cursor: pointer;" title="자원 모니터링">
          <hr>
          <b-row v-if="info.ms">
            <b-col class="rounded-lg pt-2 m-2" sm="2">
              <vue-speedometer
                  class="fadeIn fadeOut animated"
                  v-if="info.status && info.status.system_memory_info"
                  style="display:inline-block; height:90px; float:left;"
                  :width="100"
                  :height="100"
                  :needleHeightRatio="0.4"
                  :value="ramStatus"
                  :customSegmentStops='[0, 250, 750, 1000]'
                  :segmentColors='["#22dc6d", "#ffc90e", "#ed1c24"]'
                  :currentValueText="`RAM(${ramStatus} %)`"
                  :customSegmentLabels='[ { text: "L", position: "INSIDE", color: "#fff", }, { text: "N", position: "INSIDE", color: "#fff", }, { text: "H", position: "INSIDE", color: "#fff", }, ]'
                  :ringWidth="18"
                  :needleTransitionDuration="1000"
                  needleTransition="easeElastic"
                  needleColor="#a7ff83"
                  textColor="#000"
                />

                <br>
                <vue-speedometer
                class="fadeIn fadeOut animated"
                v-if="info.status && info.status.system_cpu_info"
                style="display:inline-block; height:90px; float:left;"
                :width="100"
                :height="100"
                :needleHeightRatio="0.4"
                :value="cpuStatus"
                :customSegmentStops='[0, 250, 750, 1000]'
                :segmentColors='["#22dc6d", "#ffc90e", "#ed1c24"]'
                :currentValueText="`CPU(${cpuStatus / 10 } %)`"
                :customSegmentLabels='[ { text: "L", position: "INSIDE", color: "#fff", }, { text: "N", position: "INSIDE", color: "#fff", }, { text: "H", position: "INSIDE", color: "#fff", }, ]'
                :ringWidth="18"
                :needleTransitionDuration="1000"
                needleTransition="easeElastic"
                needleColor="#a7ff83"
                textColor="#000"
              />
            </b-col>
            <b-col class="rounded-lg pt-2 m-2">
              <folderSet  :disk_list="disckStatus"/>
            </b-col>
          </b-row>
          <b-row class="text-center" v-else>
            <b-col>
              에이전트가 오프라인입니다
            </b-col>
            <b-col sm="1">
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col sm="12" class="text-center" >
              <p style="display:inline-block; cursor: pointer;" @click="setting.limit_mode = !setting.limit_mode"> <span class="mr-3">자원 모니터링 알림 설정</span> <i v-if="setting.limit_mode" class="fa fa-refresh fa-spin"></i></p>
              <c-switch class="float-right" color="success" label variant="pill" v-model="setting.limit_mode"/>
              <br>
              <small class="text-danger">시스템 자원이 임계치 이상일 경우 최초 1회 알림 발생 되며, 정상 기준이하시 재알림이 가능합니다. 임계치는 90%, 정상 기준은 60% 를 권장합니다 </small>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col sm="2" class="mt-2">CPU 임계치(90%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :disabled="!setting.limit_mode" :number="true" type="number" placeholder="90" v-model="setting.limit_cpu"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">RAM 임계치(90%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :disabled="!setting.limit_mode" :number="true" type="number" placeholder="90" v-model="setting.limit_ram"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">Disk 임계치(90%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :disabled="!setting.limit_mode" :number="true" type="number" placeholder="90" v-model="setting.limit_disk"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <!-- 여기서 라인 나눔 -->
            <b-col sm="2" class="mt-2">CPU 정상(60%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :disabled="!setting.limit_mode" :number="true" type="number" v-model="setting.resolve_cpu"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">RAM 정상(60%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                <b-form-input :disabled="!setting.limit_mode" :number="true" type="number" v-model="setting.resolve_ram"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">Disk 정상(60%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :disabled="!setting.limit_mode" :number="true" type="number" v-model="setting.resolve_disk"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </b-card>
    <!-- for modal -->
    <b-modal title="Status Save?"  class="modal-warning" v-model="status_confirm" @ok="status_save" ok-variant="danger">
      <p>해당 서버의 방화벽 사용/사용안함.</p>
    </b-modal>
    <b-modal size="xl" title="정책을 저장할까요 ?"  class="modal-warning" v-model="rule_confirm" @ok="save" ok-variant="danger" header-bg-variant="danger">
      <b-row>
        <b-col>
          <p>잘못된 규칙 설정이 서비스에 영향을 줄 수 있습니다.</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="1">
        </b-col>
        <b-col v-show="change_level_value.new != '' && change_level_value.prev != change_level_value.new">
          <p>
            <div style="display: inline-block;">
              <p>- 레벨 변경 사항</p>
              <p>
                기존 : {{ change_level_value.prev }}
              </p>
              <p>
                <strong>
                  현재 : {{ change_level_value.new }}
                </strong>
              </p>

            </div>
            <img src="img/waf_level.png" width="200" height="100" style="display: inline-block;">
          </p>
        </b-col>
        <b-col v-show="change_mode_value.new != '' && change_mode_value.prev != change_mode_value.new">
          <p>
            <div style="display: inline-block;">
              <p>- 모드 변경 사항</p>
              <p>
                <b-badge v-if="change_mode_value.prev == 0" variant="secondary">미사용</b-badge>
                <b-badge v-else-if="change_mode_value.prev == 1" variant="warning">탐지 모드</b-badge>
                <b-badge v-else-if="change_mode_value.prev == 2" variant="danger">차단</b-badge>
                =>
                <b-badge v-if="change_mode_value.new == 0" variant="secondary">미사용</b-badge>
                <b-badge v-else-if="change_mode_value.new == 1" variant="warning">탐지 모드</b-badge>
                <b-badge v-else-if="change_mode_value.new == 2" variant="danger">차단</b-badge>
              </p>
            </div>
            <!-- 탐지 모드 사진 -->
            <img v-if="change_mode_value.new == 1" src="img/wc_detect.png" width="300" style="display: inline-block; margin-left: 20px;">
            <!-- 차단 모드 사진 -->
            <img v-if="change_mode_value.new == 2" src="img/wc_block.png" width="300" style="display: inline-block; margin-left: 20px;">
          </p>
        </b-col>

      </b-row>

      <h5 class="float-left" v-if="policy_changed && policy_changed.length > 0">CRS Policy 변경 사항만 표시됩니다</h5>
      <h5 class="float-right" v-if="policy_changed && policy_changed.length > 0">총 변경 : {{ policy_changed.length || 0 }}</h5>

      <b-table v-if="policy_changed && policy_changed.length > 0" ref="_list_changed" striped hover small fixed class="table-responsive-sm" :items="policy_changed" :fields="changed_fields" empty-text="not found">

      <!-- <h5 class="float-right">총 변경 : {{ policy_changed.length }}</h5>
      <b-table v-if="policy_changed" ref="_list_changed" striped hover small fixed class="table-responsive-sm" :items="policy_changed" :fields="changed_fields" empty-text="not found"> -->
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template slot="key" slot-scope="row">
          {{ row.item.key }}
        </template>
        <template slot="desc" slot-scope="row">
          {{ruleI18n[row.item.key] ? ruleI18n[row.item.key]['KO'] : row.item.message.message }}
        </template>
        <template slot="level" slot-scope="row">
          {{row.item.level}}
        </template>
        <template slot="severity" slot-scope="row">
          <b-badge v-if="row.item.severity == 'emergency'" variant="danger">{{row.item.severity}}</b-badge>
          <b-badge v-if="row.item.severity == 'critical'" variant="danger">{{row.item.severity}}</b-badge>
          <b-badge v-else-if="row.item.severity == 'error'" variant="warning">{{row.item.severity}}</b-badge>
          <b-badge v-else-if="row.item.severity == 'notice'" variant="warning">{{row.item.severity}}</b-badge>
          <b-badge v-else-if="row.item.severity == 'warning'" variant="warning">{{row.item.severity}}</b-badge>
          <b-badge v-else-if="row.item.severity == 'alert'" variant="dark">{{row.item.severity}}</b-badge>
          <b-badge v-else variant="light">{{'None'}}</b-badge>
        </template>
        <template slot="use" slot-scope="row">
          <b-badge v-if="row.item.origin_use" variant="success">사용</b-badge>
          <b-badge v-else variant="dark">미사용</b-badge>
          =>
          <b-badge v-if="row.item.use" variant="success">사용</b-badge>
          <b-badge v-else variant="dark">미사용</b-badge>
        </template>
        <template slot="mode" slot-scope="row">
          <b-badge v-if="row.item.origin_mode" variant="danger">차단</b-badge>
          <b-badge v-else variant="warning">탐지</b-badge>
          =>
          <b-badge v-if="row.item.mode" variant="danger">차단</b-badge>
          <b-badge v-else variant="warning">탐지</b-badge>
          <!-- <b-button size="sm" :disabled="is_add_domain_lock || row.item.temp" variant="outline-warning" @click="domain_manage_regist(row.item.domain, `${row.item.domain}.${(new Date()).getTime()}`)">Clone</b-button>
          <b-button :disabled="is_add_domain_lock" v-if="row.item.domain != 'default'" size="sm" variant="outline-danger" @click="domain_direct_remove(row.item)">Remove!</b-button> -->
        </template>
      </b-table>
    </b-modal>
    <!-- 레벨 설명 모달 -->
    <b-modal title="Explain Level Coverage"  class="modal-info text-center" v-model="explain_level" ok-only no-close-on-backdrop ok-variant="success">
      <div class="text-center">
        <img src="img/waf_level.png"
          class="text-center"
          style="margin-left: auto; margin-right: auto;width: 90%;"
        >
      </div>
      <hr>
      레벨4는 정책레벨 1 ~ 4 로 탐지합니다.<br>
      레벨3는 정책레벨 1 ~ 3 로 탐지합니다.<br>
      레벨2는 정책레벨 1 ~ 2 로 탐지합니다.<br>
      레벨1은 정책레벤 1로 탐지합니다.<br>
      <hr>
      <p>
        레벨이 높을수록 보다 많은 범위의 공격이 탐지됩니다.
        레벨 설정 후, 상세 정책 설정을 권장합니다
      </p>
    </b-modal>

    <!-- 다른 서버 적용 모달 -->
    <b-modal hide-footer title="해당 정책을 다른 에이전트에 적용" size="xl" v-model="apply_modal" header-bg-variant='warning'>
      <!-- <b-button size="sm" variant="primary" @click="() => { policy_list = server.policy_json.domains.map(r => r.domain) }"> Select All </b-button> -->
      <b-button size="sm" variant="warning" @click="policy_list = []"> 지우기 </b-button>
      <hr>
      <p class="m-2">
        <b-form-checkbox-group class="m-2"  v-model="policy_list">
          <b-form-checkbox v-for="policy in server.policy_json.domains" :key="policy.id"  :value="policy.domain">
            {{policy.domain}}
          </b-form-checkbox>
        </b-form-checkbox-group>
      </p>
      <hr v-if="apply_all_server && apply_all_server.length > 0">
      <b-badge variant="success" v-for="(item, index) in apply_all_server" :key="index" class="m-1">
        <h6 @click="multi_remove(index)" style="cursor:pointer;">{{item.nickname}} <span class="m-1" style="cursor:pointer;">X</span></h6>
      </b-badge>
      <hr>
      <agent-List :agent_id="server.id" :list_selected="apply_all_server"  :only_select="true" @multi_clear="multi_clear" @multi_all="multi_all" @multi_one="multi_one"></agent-List>
      <hr>
      <b-button block variant="warning" @click="apply_confirm_modal = true" class="m-1 btn-addition">적용</b-button>
      <b-button block variant="info" @click="apply_modal = false" class="m-1">닫기</b-button>
    </b-modal>
    <!-- 다른 서버 적용 모달 다시 확인 -->
    <b-modal hide-footer title="Confirm for apply to policy" size="xm" v-model="apply_confirm_modal" header-bg-variant='danger'>
      선택한 에이전트에 설정을 적용하시겠습니까?
      <hr>
      <b-button block variant="danger" @click="multi_save" class="m-1 btn-addition">적용</b-button>
      <b-button block variant="info" @click="apply_confirm_modal = false" class="m-1">닫기</b-button>
    </b-modal>
    <!-- 방화벽 운영 모드 관련 안내 모달 -->
    <b-modal title="Domain Manage" class="modal-info" size="xl" v-model="explain_user_crs" no-close-on-backdrop ok-only @ok="explain_user_crs = false">
      <b-table ref="_list" striped hover small fixed class="table-responsive-sm" :items="server && server.policy_json && server.policy_json.domains" :fields="domain_manage_fields" empty-text="not found">
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template slot="domain" slot-scope="row">
          <b-form-input @change="change_policy_name" :disabled="('default' == row.item.domain && row.index == 0) || !row.item.temp" class="pull-right m-1" size="sm" v-model="row.item.domain"></b-form-input>
        </template>
        <template slot="status" slot-scope="row">
          <b-badge v-if="row.item.temp" variant="danger">저장되지않음</b-badge>
          <b-badge v-else variant="success">사용중</b-badge>
          <span v-if="row.item.domain == sel_domain.domain">*</span>
        </template>
        <template slot="mode" slot-scope="row">
          <!-- {{row.item.mode}} -->
          <b-badge v-if="row.item.mode == codes.WAF_MODE_OFF.VALUE || row.item.mode == codes.WAF_MODE_OFF.TEXT" variant="secondary">Off</b-badge>
          <b-badge v-if="row.item.mode == codes.WAF_MODE_DETECTIONONLY.VALUE || row.item.mode == codes.WAF_MODE_DETECTIONONLY.TEXT" variant="warning">탐지</b-badge>
          <b-badge v-if="row.item.mode == codes.WAF_MODE_ON.VALUE || row.item.mode == codes.WAF_MODE_ON.TEXT" variant="danger">차단</b-badge>
        </template>
        <template slot="level" slot-scope="row">{{row.item.level}}</template>
        <template slot="button" slot-scope="row">
          <b-button size="sm" :disabled="is_add_domain_lock || row.item.temp" variant="outline-warning" @click="domain_manage_regist(row.item.domain, `${row.item.domain}.${(new Date()).getTime()}`)">복사</b-button>
          <b-button :disabled="is_add_domain_lock"  v-if="row.item.domain != 'default'" size="sm" variant="outline-danger" @click="domain_direct_remove(row.item)">삭제!</b-button>
        </template>
      </b-table>
      <hr>
      <p>
        <span v-if="!auth.license.onPremise" class="float-left font-weight-bold text-danger">과금시, 서브 도메인은 하나의 도메인으로 구분합니다.</span>
        <b-button class="btn-add pull-right m-1" size="sm" variant="success" @click="domain_manage_regist()">추가</b-button>
        <b-form-input class="pull-right m-1" size="sm" v-model="domain" @keyup.native.enter="domain_manage_regist()" placeholder="Domain Add Enter" style="max-width: 20rem;"></b-form-input>
      </p>
    </b-modal>
    <b-modal title="Domain Remove" class="modal-danger" v-model="explain_user_domain" no-close-on-backdrop @ok="domain_manage_remove()" header-bg-variant="danger">
      기존 존재한 도메인 삭제시 작업 사항이 같이 저장됩니다
      기존 도메인 설정은 삭제됩니다
      삭제하시겠습니까?
    </b-modal>
    <!-- 모드 설명 모달 -->
    <b-modal title="Explain Mode"  class="modal-info text-center" v-model="explain_mode" ok-only no-close-on-backdrop ok-variant="success">
      <b-badge variant="warning">안내</b-badge> :
      <strong> 정책 레벨이 1 이상으로 설정시 운용중인 서비스에 영향을 줄 수 있습니다. </strong><br>
      <hr>
      <strong> * 미사용 : 웹 캐슬 사용안함 </strong><br>
      <strong> * 탐지모드 : 악의적인 공격을 탐지만 수행합니다 </strong><br>
      <strong> * 차단모드 : 악의적인 공격에 대해 탐지하여 차단을 수행합니다 </strong><br>
      <!-- <strong> * Multiplexing : Managed by a multiplexed firewall policy </strong> -->
      <hr>
      <p class="text-center">
        <b-img v-bind="{ width: 300, height: 300, class: 'm1' }" src="img/multi.png" alt="Multiplexing"></b-img>
      </p>
    </b-modal>
    <!-- 모드 설명 모달 -->
    <b-modal title="정책 기본 버전 변경"  class="modal-warning text-center" v-model="change_main_policy" no-close-on-backdrop ok-variant="success" hide-footer>
      <b-badge variant="warning">안내</b-badge>
      <strong> 방화벽 정책 변경 </strong>
      <hr>
      <p>정책 버전 [ {{crs_rule.version}} ] => <span class="font-weight-bold text-danger">[ {{target_crs_rule.version}} ]</span> </p>
      <hr>
      <p>필요한 최소 에이전트 버전 [ {{crs_rule.agent_version ? crs_rule.agent_version : '-'}} ] => <span class="font-weight-bold text-danger">[ {{target_crs_rule.agent_version ? target_crs_rule.agent_version : '-'}} ]</span> </p>
      <hr>
      <p class="text-danger">* 기본 정책을 변경하여 페이지가 새로 고쳐집니다</p>
      <hr>
      <small class="font-weight-bold">* 정책을 변경한 후 문제가 발생하면 정책을 다시 복원할 수 있습니다</small>
      <hr>
      <div class="modal-footer">
        <b-button block class="btn btn-success" @click="change_crs">업데이트</b-button>
        <b-button block class="btn btn-light" @click="change_main_policy = false; target_crs_rule = crs_rule;">취소</b-button>
      </div>
    </b-modal>

    <!-- 이름 변경 모달 -->
    <b-modal title="서버 이름 수정" class="modal-warning text-center" v-model="nickname_modify_modal" no-close-on-backdrop ok-variant="success" hide-footer header-bg-variant="info">
      <p> 서버의 이름을 수정할 수 있습니다. </p>
      <p> 변경할 이름을 기입하세요. 초기 서버 이름은 서버의 호스트명입니다 </p>
      <p> <b> * 서버 이름 확인 </b> </p>
      <p> 변경 전 서버 이름 : {{server.nickname}}  </p>
      <b-form-input v-model="modify_nickname" placeholder="변경할 이름을 입력하세요"></b-form-input>

      <div class="modal-footer">
        <b-button block class="btn btn-success" @click="nickname_modify()">적용</b-button>
        <b-button block class="btn btn-light" @click="nickname_modify_modal = false">취소</b-button>
      </div>
    </b-modal>

    <!-- 이름 변경 모달 -->
    <b-modal title="이름 설정" class="modal-warning text-center" v-model="modal_name" no-close-on-backdrop ok-variant="success" hide-footer header-bg-variant="info">
      <p> 서버 호스트명과 다르게 이름을 지정할 수 있습니다 </p>
    </b-modal>

    <!-- 로그 상세 모달 -->
    <b-modal size="xl" class="modal-warning text-center" v-model="modal_log" no-close-on-backdrop ok-variant="success" hide-footer header-bg-variant="info">
      <LogDetail :id="modal_log_id" @reload="reload()" :only_view="false"/>
    </b-modal>

    <!-- 레벨 변경 모달 상세 모달 -->
    <b-modal size="ml" class="modal-warning text-center" v-model="change_level_modal" no-close-on-backdrop ok-variant="success" hide-footer header-bg-variant="warning" @close="back_level_change">
      <h6>변경된 레벨을 정책의 사용 여부에 반영합니다</h6>
      <h6>정책 레벨 변경 시 이전에 설정되어 있는 정책을 반영할까요?</h6>
      <hr>
      <strong>- YES</strong><br>
      변경된 레벨의 정책들을 사용으로 설정합니다<br>
      일괄적으로 변경된 레벨에 해당하는 정책을 사용으로 설정합니다<br>
      <br>
      <strong>- No</strong><br>
      변경된 레벨의 정책들을 사용으로 설정하지 않습니다<br>
      이 경우, 정책 사용으로 설정시 수동으로 사용 여부 설정(체크박스 클릭)이 필요합니다<br>
      <br>
      <div class="modal-footer">
        <b-button block class="btn btn-success" @click="() => { toggle_depend_level(); change_level_modal = false; }">Yes</b-button>
        <b-button block class="btn btn-light" @click="change_level_modal = false">No</b-button>
      </div>
    </b-modal>

    <!-- 적용 실패 안내 -->
    <b-modal :title="webcastle_alert_is_error ? '장애 알림' : '저장 성공'" size="ml" :class="`modal-${webcastle_alert_is_error ? 'danger' : 'success'} text-center`" v-model="webcastle_alert" no-close-on-backdrop :ok-variant="webcastle_alert_is_error ? 'danger' : 'success'" ok-only :header-bg-variant="webcastle_alert_is_error ? 'danger' : 'success'">
      <h4 v-if="webcastle_alert_is_error" class="text-danger font-weight-bold">변경된 정책을 적용 중 문제가 발생하였습니다</h4>
      <h4 v-if="webcastle_alert_is_error" class="text-danger font-weight-bold">웹 방화벽 장애 상태로 이전 설정으로 저장이 필요합니다</h4>
      <h4 v-else class="font-weight-bold"></h4>
      <hr>
      <p>
        msg : {{ webcastle_alert_msg || '-' }}
      </p>
      <br>
    </b-modal>

    <!-- 설정 업로드 모달 -->
    <b-modal title="정책 내보내기 / 가져오기" size="ml" :class="`modal-${webcastle_alert_is_error ? 'danger' : 'success'} text-center`" v-model="upload_policy" no-close-on-backdrop ok-variant="success" ok-only header-bg-variant="success" @ok="upload_policy_save">


      <b-form-file
      v-model="upload_policy_file"
      :state="Boolean(upload_policy_file)"
      placeholder="Choose a file or drop it here..."
      drop-placeholder="Drop file here..."
      @change="upload_policy_change"
    ></b-form-file>

    <b-form-group class="mt-2" label="적용할 도메인을 선택하세요">
      <b-form-checkbox
        v-for="(item, index) in upload_policy_data.domains"
        v-model="upload_policy_selected"
        :key="item.domain"
        :value="item.domain"
      >
        {{item.domain}}
      </b-form-checkbox>
    </b-form-group>
    <span class="text-danger">* 매칭되는 도메인 설정은 덮어쓰기, 없는 정책은 생성됩니다</span>
    <br>
    <span class="text-danger">* 정책 파일이 정확하지 않을 경우 업로드 실패할 수 있습니다</span>
    <br>
    <span class="text-danger">* 업로드 된 정책은 꼭 확인 후 저장하세요</span>
    </b-modal>

    <b-modal title="서버 삭제"  class="modal-danger" v-model="modal_del" @ok="remove" @cancel="del_nickname = '';" header-bg-variant="danger" ok-variant="danger">
      <p> 이곳에서 에이전트를 삭제해도 서버에서는 자동삭제되지 않습니다. 먼저 서버에서 삭제할 것을 권장드립니다.  </p>
      <p> 삭제된 경우 방화벽 역활을 수행하지 않습니다.  </p>
      <p> <b> * 서버 이름 확인 </b> </p>
      <p> 삭제할 서버이름 확인 : {{server.nickname}}  </p>
      <b-form-input v-model="del_nickname" placeholder="삭제할 서버의 이름을 입력해주세요."></b-form-input>
    </b-modal>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
